// import { ReportAllocatedAndSubsidies38Component } from "../../../components/SupportSystem/Reports/ReportAllocatedAndSubsidies38Component";
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
import { NewReportAllocatedAndSubsidies38Component } from "../../../components/SupportSystem/Reports/NewReportAllocatedAndSubsidies38Component";


export function ReportAllocatedAndSubsidies38Container() {
    const titleName = "ระบบการให้เงินช่วยเหลือหรืออุดหนุนกองทุนพัฒนาฝีมือแรงงาน";
    return(
        <div className="page-container bg-landing">
            <NavbarSupportSystem />
            <HeadTitle title={titleName} />
            {/* <ReportAllocatedAndSubsidies38Component/> */}
            <NewReportAllocatedAndSubsidies38Component/>
            <Footer />
        </div>   
        // 
    )
    
}